

<kendo-formfield>
    <kendo-label [text]="caption | translate"></kendo-label>
    <kendo-textarea  
    [ngClass]="{'fx-fill': settings.fxFill}"  
    [formControl]="control" 
    (valueChange)="onChange($event)" 
    [rows]="settings.rows" 
    [readonly]="settings.readonly"
    width="auto" > 
</kendo-textarea>
</kendo-formfield>
